import { Controller } from "@hotwired/stimulus";

export class ModalController extends Controller {
  static targets = ['modal', 'closeButton']

  afterOpen(_event) {
    _event.preventDefault();
  }

  openModal(event) {
    this.modalTarget.style.display = 'block';
    this.modalTarget.style.opacity = 1;
    this.afterOpen(event);
  }

  closeModal() {
    this.modalTarget.style.display = 'none';
    this.modalTarget.style.opacity = 0;
  }

  submit() {}
}

// Registered in customer.js
